export default {
  locale: "fr",
  name: "Modifications",
  translation: { displayName: "Configurer la question" },
  fields: {
    list: [
      {
        fieldName: "position",
        displayName: "Ordre",
      },
      {
        fieldName: "active",
        displayName: "Actif",
      },
      {
        fieldName: "ticker",
        displayName: "Identifiant",
      },
      {
        fieldName: "widgetType",
        fieldSelector: {
          INPUT: "Texte libre",
          SELECT: "Liste déroulante",
          STAY_DATE: "Sélecteur de date de séjour",
          CHECKBOX: "Case à cocher",
          RADIO: "Bullet point",
          PHONE: "Téléphone",
        },
        displayName: "Type de réponse",
      },
      {
        fieldName: "required",
        displayName: "Obligatoire",
      },
    ],
    form: [
      {
        fieldName: "position",
        widget: "hidden",
      },
      {
        fieldName: "active",
        displayName: "Actif",
        widget: "singleSwitch",
        className: "activeCheckbox",
      },
      {
        fieldName: "ticker",
        displayName: "Identifiant",
        widget: "input",
        className: "tickerInput",
      },
      {
        fieldName: "required",
        displayName: "Obligatoire",
        widget: "checkbox",
      },
      {
        fieldName: "widgetType",
        displayName: "Type de réponse",
        widget: "selector",
        optionDisplay: {
          INPUT: {
            label: "Texte libre",
          },
          SELECT: {
            label: "Liste déroulante",
          },
          CHECKBOX: {
            label: "Case à cocher",
          },
          RADIO: {
            label: "Bullet point",
          },
          STAY_DATE: {
            label: "Sélecteur de date de séjour",
          },
          PHONE: {
            label: "Téléphone",
          },
        },
        defaultValue: "INPUT",
      },
      {
        fieldName: "label",
        widget: "input",
        displayName: "Question",
        className: "tickerInput",
        translated: true,
      },
      {
        fieldName: "placeholder",
        widget: "input",
        displayName: "Information d'aide sur le champ",
        className: "tickerInput",
        translated: true,
        visible: ({ formValues }) =>
          formValues.widgetType === "INPUT" || formValues.widgetType === "SELECT",
      },
      {
        fieldName: "items",
        displayName: "Options de réponse",
        placeholder: "option1,option2,option3...",
        widget: "input",
        translated: true,
        visible: ({ formValues }) =>
          formValues.widgetType === "SELECT" ||
          formValues.widgetType === "CHECKBOX" ||
          formValues.widgetType === "RADIO",
      },
    ],
  },
};
